import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { getDuplicatesPaged, getTotalDuplicates } from '../../../API/FetchCall';

import Pagination from "react-js-pagination";
//import Pagination from 'rc-pagination';


class afterschoolList extends Component {

    constructor(props) {
        super(props);
         
        this.state = {
              logged: localStorage.getItem("authentication"),
              list: [],
              PER_PAGE:15,
              total:0,
              loading:true,
              searchby:'',
              activePage:1,
              offset:0,
        };

       
    }


    componentDidMount() {

      var THIS = this;
      this.getTotal();
      this.getDuplicateList();
    }

    getTotal = (location='') => {

        let ins = JSON.stringify({
            vertical: 'afterschool'
        });
  
        getTotalDuplicates(ins).then((res) => {
  
          this.setState({loading:true});
  
          if (res.status == 1) {
                    
            this.setState({
              
              total: res.total
              
            });
  
          } 
        });
  
    }  

    getDuplicateList = (pageNumber=1) => {

      this.setState({activePage: pageNumber});

      const newOffset = (pageNumber==1)? 0 : (((pageNumber-1) * this.state.PER_PAGE)%this.state.total);

      let req = JSON.stringify({
            vertical: 'afterschool',
            perpage:this.state.PER_PAGE,
            offset:newOffset
      })
      getDuplicatesPaged(req).then((res) => {
        if (res.status == 1) {
          this.setState({
            list: res.list
            
          });
        } else {
          this.setState({
            list: [],
          });
        }
      });
    }    



    
    handlePageChange(pageNumber) {

        console.log(`active page is ${pageNumber}`);

        this.setState({activePage: pageNumber});

        //this.getTotal('bw_schools');
        this.getDuplicateList(pageNumber);

    }      

    render() {

        const { list } = this.state;
        const { currentPage, PER_PAGE, totalCount, total } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Duplicates - Afterschool Activities</h4>
                                   
                  
                   
                  <div class="table-responsive pt-3">
                     <table class="table table-bordered table-striped">
                      <thead class="thead-dark">
                        <tr>
                          <th>
                            <strong>S.No</strong>
                          </th>
                       
                          <th>
                            <strong>School Name</strong>
                          </th>
                          
                          <th>
                            <strong>City</strong>
                          </th>
                          
                                                
                          <th>
                            <strong>Action</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {list.map((item, i) => {     
                      
                       return <tr>
                          <td>
                            {i+1}
                          </td>
                          <td>
                           {item.organisation_name}
                          </td>
                                                   
                          <td>
                           {item.location}
                          </td>

                          
                          <td  class="actionbtns" dangerouslySetInnerHTML={{__html: item.action}} />                            

                        </tr>

                      })

                      }
                       
                      </tbody>
                    </table>
                  </div>

                  <div class="text-center">
                      
                     <Pagination
                        activePage={this.state.activePage}
                        itemsCountPerPage={PER_PAGE}
                        totalItemsCount={this.state.total}
                        pageRangeDisplayed={5}
                        activeClass={"pagination__link--active"}
                        onChange={this.handlePageChange.bind(this)}
                        prevPageText="previous"
                        nextPageText="next"
                      />

                    </div>

                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default afterschoolList;


// WEBPACK FOOTER //
// ./src/components/bewise/duplicates/afterschoolList.jsx